<template>
  <div>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Imprimir etiquetas"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group description label="Tipo Etiqueta">

          <b-form-select
            v-model="$v.form.type.$model"
            :state="$v.form.type.$dirty ? !$v.form.type.$error : null"
          >
            <option value="">Seleccione</option>
            <option value="1">Etiqueta 10x15 normal</option>
            <option value="2">Etiqueta 10x15 specs abajo (solo total de cantidades)</option>
            <option value="3">Etiqueta 10x15 (solo total de kilos netos)</option>
            <option value="4">Etiqueta 10x15 tipo 2 </option>
            <option value="5">Etiqueta 10x15 V(UN)</option>
          </b-form-select>

        </b-form-group>
        <b-form-group>

          <label>Numero de etiquetas a imprimir</label>

          <b-form-input
            type="text"
            :state="$v.form.quantity.$dirty ? !$v.form.quantity.$error : null"
            v-model="$v.form.quantity.$model"
            placeholder="">
          </b-form-input>

        </b-form-group>
      </form>
    </b-modal>
    <reusable-print-pallet ref="print"></reusable-print-pallet>
  </div>
</template>

<script>

  import {required, numeric} from "vuelidate/lib/validators";
  import ReusablePrintPallet from '../reusable/reusablePrintPallet'

  export default {
    name: "PrintModal",
    components: {
      ReusablePrintPallet
    },
    data() {
      return {
        form: {

          type: null,
          quantity: null,
        }
      }
    },
    props: {
      pallet_id: {
        type: Number,
        default: 0
      }
    },
    methods: {
      checkFormValidity() {
        this.$v.form.$touch();
        return !this.$v.form.$anyError;

      },
      resetModal() {
        this.type = null;
        this.quantity = null;
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault();
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        }
        this.$refs['print'].printLabel(this.pallet_id, this.form.quantity, this.form.type );
        // Hide the modal manually
        this.$nextTick(() => {
          this.resetModal();
          this.$bvModal.hide('modal-prevent-closing')
        })
      }
    },
    validations: {
      form: {
        quantity: {
          required,
          numeric
        },
        type: {required},
      }
    }

  }
</script>

<style scoped>

</style>
